export type EEGCalibrationEnvironment = {
	screenWidth: number
	screenHeight: number
	devicePixelRatio: number
	visualViewportScale: number
}

export type EEGCalibrationRecord = {
	pxPerMm: number
	savedAt: string
	env: EEGCalibrationEnvironment
	version: number
}

export enum EEGCalibrationStatus {
	VALID = "valid",
	OUTDATED = "outdated",
	MISSING = "missing",
}

export type EEGCalibrationState = {
	status: EEGCalibrationStatus
	record?: EEGCalibrationRecord
	storageKey?: string
}

export type MonitorPreset = {
	label: string
	diagonalInches: number
	aspectRatio: number
}

export enum CalibrationTokenPrefix {
	Valid = "valid",
	Status = "status",
}
